module.exports = __webpack_public_path__ + "static/media/sanjati-ali-spati.13c18456.png";